/**
 * Modal plugin for Vue 3 with Nuxt 3
 * Registers the modal container component globally
 */
import ModalContainer from '~/components/Layout/Parts/ModalContainer.vue';

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.component('ModalContainer', ModalContainer);
});
